'use client';
import './styles/default.scss';
import { getText } from '@/utils/text/text';
import { SessionTimers } from '../session-timers';
// eslint-disable-next-line nextjs-boundaries/no-server-import-in-client
import { ImageComponent } from '@/app/elements/image-component/image-component';
import { classes } from '@/utils/classes/classes';
import { useGlobalContext } from '@/store/contexts/global-context';
import { REGIONS } from '@/utils/constants';

type ResponsibleGamblingProps = {
    text?: string;
    logo: string;
    url?: string;
    hasLogoDescription?: boolean;
    customLogoSize?: number;
};

const NORMAL_LOGO_SIZE = 20;
const ONLY_LOGO_SIZE = 40;

const REGIONS_SHOWING_RG_WITH_LOGO_ON_MOBILE: readonly string[] = [REGIONS.CT, REGIONS.MR, REGIONS.PA];

export const ResponsibleGambling = ({
    text,
    logo,
    url,
    hasLogoDescription = false,
    customLogoSize
}: ResponsibleGamblingProps) => {
    const { isAndroidWrapper, isMobile, isLoggedIn, region } = useGlobalContext();
    const showRgContent = !(
        hasLogoDescription &&
        isMobile &&
        isLoggedIn &&
        !REGIONS_SHOWING_RG_WITH_LOGO_ON_MOBILE.includes(region)
    );

    const handleClick = async () => {
        if (isAndroidWrapper && url) {
            window.open(url, '_self');
        } else {
            await (
                await import('@fanduel/cpe-um-bundle/responsible-gaming/library')
            ).ResponsibleGaming.presentResponsiblePlaySettingsAsync(undefined, true, true);
        }
    };

    const onlyLogo = !text && !hasLogoDescription;
    const logoSize = customLogoSize || (onlyLogo ? ONLY_LOGO_SIZE : NORMAL_LOGO_SIZE);

    return (
        <div className={classes(!onlyLogo && 'header-responsible-gambling-wrapper gapped')}>
            {showRgContent && (
                <div className="header-responsible-gambling">
                    {text && <p className="content">{text}</p>}

                    <div onClick={handleClick} className="logo-wrapper">
                        <ImageComponent
                            src={logo}
                            alt="responsible-gambling-logo"
                            width={logoSize}
                            height={logoSize}
                            useNext={false}
                        />

                        {hasLogoDescription && (
                            <span>{getText({ text: 'components.accountDetails.responsiblePlay' })}</span>
                        )}
                    </div>
                </div>
            )}
            {!onlyLogo && <SessionTimers />}
        </div>
    );
};
